import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import { ThemeProvider } from "styled-components";
import "chart.js/auto";
import "moment/locale/ko";

import App from "@/App";
import { rootStore } from "@/mobx/store";
import theme from "./design/defaultTheme";
import { installStaleBundleGuard } from "./utils/staleBundleGuard";

// 전역 CSS 는 카리아카와 같은 순서로 싣는다 — 순서가 바뀌면 화면이 달라진다.
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/default/app.min.css";
import "./styles/scrollbar.css";
import "./design/cari-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <Provider rootStore={rootStore}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);

installStaleBundleGuard();
